import React from "react";

export default function IconCross({className}: any) {
    return <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M23 7L7 23M23 7L7 23M23 7L7 23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M7 7L23 23M7 7L23 23M7 7L23 23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
}